module.exports = __webpack_public_path__ + "static/media/infaq2.bc84867a.jpg";